import { Tag } from "@ttc3k/trekker";
import { Product } from "gql/generated";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getProductTypeConfig } from "shared/config/productTypeConfig";

function isMembershipLinkedProduct(product: Product): boolean {
  return !!(
    product.renewableFeeMetadata?.membershipLinked ||
    product.sellingConfig?.recurring?.membershipLinked
  );
}

type ProductTypeTagProps = {
  product: Product;
};

export const ProductTypeTag = ({ product }: ProductTypeTagProps) => {
  const { t } = useTranslation("storefront", {
    keyPrefix: "BOOKING_WIDGET_SETUP",
  });
  const { t: tInventory } = useTranslation("storefront", {
    keyPrefix: "INVENTORY",
  });

  const label = useMemo(() => {
    if (isMembershipLinkedProduct(product)) {
      return t("PRODUCT.PRODUCT_TYPE_SELECTION.MEMBERSHIP_FEE", {
        membership: "Membership",
      });
    }
    const { i18nKey } = getProductTypeConfig(product.type);
    return tInventory(`PRODUCT_TYPES.${i18nKey}`);
  }, [product, t, tInventory]);

  return (
    <Tag visual="highlight" mode="light" size="sm" w="fit-content">
      {label}
    </Tag>
  );
};
